@if (channel) {
  <shared-modal [mobile]="sharedService.screenSize !== 'l'">
    <!-- header -->
    <h2 slot="header">Editar número</h2>

    <!-- body -->
    <div class="flex flex-col gap-3">
      <input
        placeholder="Nome"
        [(ngModel)]="channel.name"
        [disabled]="loading" />
      <div class="flex gap-3">
        <input
          class="w-20"
          no-clear
          placeholder="País"
          maxlength="2"
          [value]="number.countryCode"
          (input)="setNumber('countryCode', $event, 3)"
          [attr.readonly]="id"
          [disabled]="loading" />
        <input
          class="w-20"
          no-clear
          placeholder="DDD"
          [value]="number.areaCode"
          (input)="
            setNumber('areaCode', $event, number.countryCode === '55' ? 2 : 4)
          "
          [attr.readonly]="id"
          [disabled]="loading" />
        <input
          class="flex-1"
          no-clear
          placeholder="Número"
          [value]="number.number"
          (input)="
            setNumber('number', $event, number.countryCode === '55' ? 8 : 15)
          "
          [attr.readonly]="id"
          [disabled]="loading" />
      </div>
    </div>

    <!-- footer -->
    @if (channel.uid) {
      <button
        class="mr-auto tertiary"
        slot="footer"
        (click)="delete()"
        [disabled]="loading">
        Deletar
      </button>
    }
    <button
      slot="footer"
      class="secondary"
      (click)="sharedService.closeModal(route)"
      [disabled]="loading">
      Cancelar
    </button>
    <button
      slot="footer"
      [disabled]="!channel.name || !channel.numbers.length || loading"
      (click)="save()">
      {{ loading ? 'Salvando...' : 'Confirmar' }}
    </button>
  </shared-modal>
}
